export default [
    {
        name:"allDynamic",
        path:"allDynamic",
        component:()=>import("@/view/WebViews/Dynamic/allDynamic"),
        meta:{
            title:"全部动态",
        }
    },
    {
        name:"IndustryNews",
        path:"IndustryNews",
        component:()=>import("@/view/WebViews/Dynamic/IndustryNews"),
        meta:{
            title:"行业新闻",
        }
    },
    {
        name:"CompanyDynamic",
        path:"CompanyDynamic",
        component:()=>import("@/view/WebViews/Dynamic/CompanyDynamic"),
        meta:{
            title:"公司动态",
        }
    },
    {
        name:"KnowledgeSharing",
        path:"KnowledgeSharing",
        component:()=>import("@/view/WebViews/Dynamic/KnowledgeSharing"),
        meta:{
            title:"知识分享",
        }
    },
    {
        name:"DynamicDetail",
        path:":url/DynamicDetail",
        component:() => import("@/view/WebViews/Dynamic/DynamicDetail"),
    },
]